import React from 'react'
import { useTranslation } from 'react-i18next'

import styled from 'styled-components'

const PageNotFoundWrap = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 100px);
  color: #000;
  @media (max-width: 768px) {
    min-height: calc(100vh - 224px);
  }
`

const NotFound: React.FunctionComponent = () => {
  const { t } = useTranslation()
  return <PageNotFoundWrap>{t('ERROR_1')}</PageNotFoundWrap>
}

export default NotFound
